module.exports = "\n<bk-form-select [control]=\"control\" [options]=\"_options\"></bk-form-select>\n"